import React from 'react';
import Icon from 'components/lib/icons/icon';

/**
 * @visibleName Facebook Messenger Fill
 */

export default function FacebookMessengerFillIcon(props) {
  return (
    <Icon viewBox="0 0 16 16" {...props}>
      <path
        clipRule="evenodd"
        d="M15 7.5C15 11.0899 11.866 14 8 14C7.15393 14 6.34292 13.8606 5.59215 13.6052L3.5 15V12.4791C1.97153 11.2868 1 9.49873 1 7.5C1 3.91015 4.13401 1 8 1C11.866 1 15 3.91015 15 7.5ZM3.89205 9.05194L6.92961 5.58044C6.96771 5.53691 7.03468 5.53468 7.07558 5.57558L8.94599 7.44599C8.97788 7.47788 9.02716 7.48448 9.06632 7.46211L12.0611 5.7508C12.1562 5.69645 12.2569 5.81255 12.1897 5.89901L9.07783 9.89993C9.03814 9.95096 8.96119 9.95149 8.92081 9.90101L7.05343 7.56679C7.02267 7.52834 6.96849 7.51801 6.92573 7.54244L4.01692 9.20461C3.91898 9.26058 3.81777 9.13684 3.89205 9.05194Z"
        fillRule="evenodd"
      />
    </Icon>
  );
}
